import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Typography, Modal, Fade, Backdrop } from '@material-ui/core';
import useStyles from './styles';
// import useMedia from "use-media";

interface popProp {
    setOpen: ((value: boolean) => void)
    open: boolean
}

const PopModal = ({ open, setOpen }: popProp) => {

    // const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile') || '{ "result": { "name": "","imageUrl": ""}}'));
    // const dispatch = useDispatch();
    // const location = useLocation();
    // const history = useHistory();
    const classes = useStyles();
    // const commonClasses = useCommonStyles();
    // const [open, setOpen] = React.useState(false);

    // const handleOpen = () => {
    //     setOpen(true);
    // };
    const handleClose = () => {
        setOpen(false);
    };


    // const isLarger820 = useMedia({ minWidth: "820px" });
    return (<Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <div className={classes.paper}>
                        <Typography component={'span'} variant="subtitle1">新規登録に進む</Typography><br /><br />
                        <Typography component={'span'} variant="subtitle2"></Typography><br /><br />
                        <div className={classes.center}>
                            <Button component={Link} to="#" variant="contained" color="secondary" className={classes.goBackBtn} onClick={handleClose}>戻る</Button>
                            <Button component={Link} to="/betaform" variant="contained" color="primary" className={classes.betaBtn} onClick={handleClose}>登録</Button>
                        </div>
                    </div>
                </Fade>
            </Modal>
    )
}

export default PopModal;
